module.exports = __webpack_public_path__ + "b5dfc55cf174fed3a21e87d3931824ae.png";